import { DRAWER_WIDTH } from './chunk-CUKHRH2F.js';
import { StyledTypo_default } from './chunk-MYGKM72Z.js';
import { ErrorBoundary_default } from './chunk-NJFJDBQA.js';
import { ThemeProvider } from './chunk-J2FXRRBJ.js';
import { KeyboardArrowDownRounded, KeyboardArrowUpRounded } from '@mui/icons-material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useMediaQuery, useScrollTrigger, Icon } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import React, { useRef, useEffect } from 'react';

var MenuLink = ({
  onClick,
  label,
  icon
}) => /* @__PURE__ */ React.createElement(MenuItem, { onClick, sx: { minWidth: 150 } }, /* @__PURE__ */ React.createElement(ListItemIcon, null, typeof icon === "string" ? /* @__PURE__ */ React.createElement(Icon, null, icon) : icon), /* @__PURE__ */ React.createElement(ListItemText, null, label));
var TopbarComponent = ({
  drawerState,
  children,
  title,
  logout,
  currentUser,
  navigate,
  renderOptions,
  menuOptions,
  hideUserInfo,
  drawerWidth = DRAWER_WIDTH.OPEN,
  drawerCloseWidth = DRAWER_WIDTH.CLOSE
}) => {
  var _a, _b, _c;
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("md"));
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0
  });
  const appBarRef = useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [topbarHeight, setTopbarHeight] = React.useState(60);
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = React.useCallback(
    (path) => {
      try {
        setAnchorEl(null);
        setTimeout(() => {
          if (path && typeof path === "string") navigate(path);
        }, 500);
      } catch (error) {
      }
    },
    [anchorEl, navigate]
  );
  useEffect(() => {
    if (!appBarRef.current) return;
    const element = appBarRef.current;
    const resizeObserver = new ResizeObserver((entries) => {
      var _a2, _b2, _c2;
      for (const entry of entries) {
        const height = (_c2 = (_b2 = (_a2 = entry.borderBoxSize) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.blockSize) != null ? _c2 : entry.target.clientHeight;
        setTopbarHeight(height);
      }
    });
    resizeObserver.observe(element);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  return /* @__PURE__ */ React.createElement(ThemeProvider, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ErrorBoundary_default, { componentName: "Topbar" }, /* @__PURE__ */ React.createElement(Box, { sx: { flexGrow: 1 } }, /* @__PURE__ */ React.createElement(
    AppBar,
    {
      ref: appBarRef,
      position: "fixed",
      elevation: trigger ? 4 : 0,
      sx: {
        bgcolor: {
          sm: "#fff",
          xs: "#122937"
        },
        height: {
          sm: "auto",
          xs: "70px"
        },
        display: {
          sm: "block",
          xs: "flex"
        },
        justifyContent: "center",
        borderBottom: "1px solid #E6E6E6",
        width: {
          sm: drawerState ? `calc(100vw - ${drawerWidth}px)` : `calc(100vw - ${drawerCloseWidth}px)`,
          xs: "100%"
        },
        left: {
          sm: drawerState ? `${drawerWidth}px` : `${drawerCloseWidth}px`,
          xs: "auto"
        },
        transition: theme.transitions.create(["width", "left"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        })
      }
    },
    /* @__PURE__ */ React.createElement(Toolbar, null, /* @__PURE__ */ React.createElement(Box, { display: "flex", alignItems: "center" }, title), /* @__PURE__ */ React.createElement(Box, { sx: { flexGrow: 1 } }), /* @__PURE__ */ React.createElement(
      Box,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          width: {
            sm: "auto",
            xs: "100%"
          }
        }
      },
      renderOptions && renderOptions(),
      /* @__PURE__ */ React.createElement(
        Button,
        {
          variant: "text",
          sx: {
            minWidth: "auto",
            p: "4px",
            px: hideUserInfo ? "4px" : "12px",
            borderRadius: hideUserInfo ? "50%" : "4px",
            "& .MuiButton-startIcon": hideUserInfo ? {
              m: 0
            } : {
              mr: {
                md: "8px",
                xs: 0
              }
            }
          },
          startIcon: /* @__PURE__ */ React.createElement(
            Avatar,
            {
              sx: {
                height: {
                  sm: hideUserInfo ? 34 : 28,
                  xs: 34
                },
                width: {
                  sm: hideUserInfo ? 34 : 28,
                  xs: 34
                },
                fontSize: {
                  sm: "16px !important",
                  xs: "16px !important"
                },
                lineHeight: "initial",
                "& .MuiAvatar-root": {
                  fontSize: {
                    sm: "12px",
                    xs: "16px"
                  }
                }
              },
              src: (_a = currentUser == null ? void 0 : currentUser.photoURL) != null ? _a : null
            },
            (_c = (_b = currentUser == null ? void 0 : currentUser.displayName) == null ? void 0 : _b.charAt(0)) == null ? void 0 : _c.toUpperCase()
          ),
          onClick: handleProfileMenuOpen,
          endIcon: !sm && !hideUserInfo && (!anchorEl ? /* @__PURE__ */ React.createElement(
            KeyboardArrowDownRounded,
            {
              sx: {
                color: {
                  sm: "#000",
                  xs: "#D9D9D9"
                },
                fontSize: {
                  sm: "20px",
                  xs: "28px !important"
                }
              }
            }
          ) : /* @__PURE__ */ React.createElement(
            KeyboardArrowUpRounded,
            {
              sx: {
                color: {
                  sm: "#000",
                  xs: "#D9D9D9"
                },
                fontSize: {
                  sm: "20px",
                  xs: "28px !important"
                }
              }
            }
          ))
        },
        !sm && !hideUserInfo && /* @__PURE__ */ React.createElement("span", { style: { textAlign: "left", marginLeft: 8 } }, /* @__PURE__ */ React.createElement(
          StyledTypo_default,
          {
            fs: 12,
            color: "#1E1E1E",
            style: { textTransform: "capitalize" }
          },
          currentUser.displayName ? currentUser.displayName : currentUser.name || ""
        ), /* @__PURE__ */ React.createElement(
          StyledTypo_default,
          {
            fs: 12,
            fw: 400,
            color: "#1E1E1E",
            sx: { opacity: 0.2 },
            style: { textTransform: "lowercase" }
          },
          currentUser.email
        ))
      )
    ))
  ), /* @__PURE__ */ React.createElement(
    Menu,
    {
      anchorEl,
      disableScrollLock: true,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      id: "primary-search-account-menu",
      keepMounted: true,
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      open: Boolean(anchorEl),
      onClose: handleMenuClose,
      sx: {
        "& .MuiTypography-root": {
          fontSize: 12,
          fontWeight: 400
        }
      },
      PaperProps: {
        sx: {
          position: { xs: "fixed" },
          top: 0,
          left: 0,
          width: { xs: "100%", sm: "auto" }
        }
      }
    },
    menuOptions.map((option, index) => {
      return /* @__PURE__ */ React.createElement(
        MenuLink,
        {
          key: option.label + index,
          onClick: () => {
            handleMenuClose(option.path);
          },
          label: option.label,
          icon: option.icon
        }
      );
    }),
    logout != null && /* @__PURE__ */ React.createElement(
      MenuLink,
      {
        onClick: () => {
          handleMenuClose();
          logout();
        },
        label: "Logout",
        icon: /* @__PURE__ */ React.createElement(LogoutIcon, null)
      }
    )
  )), /* @__PURE__ */ React.createElement(
    Toolbar,
    {
      sx: {
        minHeight: `${topbarHeight - 1}px !important`
        // -1px to account for border
      }
    }
  )), children));
};
var Topbar_default = TopbarComponent;

// src/components/Topbar/index.ts
var Topbar_default2 = Topbar_default;

export { TopbarComponent, Topbar_default2 as Topbar_default };
//# sourceMappingURL=chunk-V3X2FFYB.js.map
//# sourceMappingURL=chunk-V3X2FFYB.js.map